import { IDelayRouteDto } from "../apis/interfaces/IDelayRouteDto";

// https://developers.google.com/maps/documentation/urls/guide
export function GetGoogleMapLink(routeDto: IDelayRouteDto){
   
    const url = `https://www.google.com/maps/dir/?api=1&origin=${routeDto.entryPointLat},${routeDto.entryPointLon}
    &destination=${routeDto.entryPointLat},${routeDto.exitPointLon}&travelmode=transit`
    return url;
}